import * as React from 'react';
import IdleTimer from 'react-idle-timer';
import '@synergycms_core/less/fonts.css';
import styleFile from './App.js';
import Modal from '@synergycms_core/components/generic/Modal';
import RichText from '@synergycms_core/components/generic/RichText';
import Button from '@synergycms_core/components/generic/Button';
import { connect } from 'react-redux';
import CustomerForm from '../../views/customerForm/CustomerForm.jsx';
import { AVAIL_LIFETIME } from '../../config/constants';
import Image from '@synergycms_core/components/generic/Image';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import propertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose } from 'ramda';

import { Loading } from '@synergycms_core/components/functional/Loading';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

//import Header from '../../components/functional/Header';

const TimeoutModal = class TimeoutModal extends React.Component {
  static displayName = 'TimeoutModal';

  constructor(props) {
    super(props);
    this.state = {
      success: false
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.timeoutModalTable}>
        <div className={classes.timeoutModalTableCell}>
          <div className={classes.timeoutModalWhite}>
            <Image svg={'sessionOut'} />
            <RichText innerStyle={classes.timeoutModalTitle} text={'_%cierre de sesión%_'} translate={true} />
            <div className={classes.timeoutModalButton}>
              <Button
                innerStyle={['buttonStyleTimeout']}
                onClick={this.props.reload}
                richText={{
                  text: '_%aceptar%_',
                  innerStyle: [classes.buttonTextStyle, 'uppercase'],
                  translate: true
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
};


class App extends React.Component {
  static displayName = 'App';

  constructor(props) {
    super(props);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.reload = window.location.reload.bind(window.location);

    this.state = {
      userIsIdle: false
    };
  }

  render() {
    const { classes } = this.props.theme.styles;

    return (
      <div className={[classes.app, classes.baseReset].join(' ')}>
        <IdleTimer element={document} onActive={this.onActive} onIdle={this.onIdle} timeout={AVAIL_LIFETIME} />
        {/*<Header innerStyle={[classes.header]} />*/}
        <CustomerForm />
        {this.state.userIsIdle && (
          <Modal
            innerStyle={classes.timeoutModalContainer}
            contentStyle={classes.timeoutModalContent}
            instantToggle={true}
            filterModal={true}
            preventToggleModal={true}
            popover={
              <TimeoutModal
                classes={classes}
                reload={this.reload}
                theme={this.props.theme.theme}
              />
            }
            typeModal={'timeoutTooltip'}
            defaultStyle={false}
          />
        )}
      </div>
    );
  }

  _onActive(e) {
    this.setState({ userIsIdle: false });
  }

  _onIdle(e) {
    this.setState({ userIsIdle: true });
  }
}

const mapStateToProps = store => {
  return {
    loaded: store.getIn(['app', 'loaded']) || undefined
  };
};

const fragment = props => {
  return (
    <React.Fragment>
      <Loading
        image={{ innerStyle: ['displayNone'] }}
        richText={{
          translate: true,
          ucFirst: true,
          innerStyle: ['descriptionText'],
          text: '_%Cargando%_'
        }}
      />
    </React.Fragment>
  );
};

export default compose(
  validateAsyncComponent(mapStateToProps, [], fragment),
  connect(mapStateToProps),
  propertyManager(['loaded']),
  withThemeJSS({ styleFile, link: true })
)(App);
